import Head from "next/head";
import React from "react";
import Layout from "../components/layout";
import Contact from "../components/contact/contact";
import Intro from "../components/intro/intro";
import About from "../components/about/about";
import Gallery from "../components/gallery/gallery";
import Newsletter from "../components/newsletter/newsletter";
import UpcomingEventsContainer from "../components/events/events-container";
import Reservations from "../components/reservations/reservations";

const Home: React.FC = () => {
  return (
    <Layout>
      <Head>
        <title>Pivovarská restaurace Čáslav</title>
      </Head>
      <Intro />
      {/* <UpcomingEventsContainer /> */}
      <Reservations />
      <About />
      {/* <Form /> */}
      {/* <Gallery /> */}
      <Newsletter />
      <Contact />
    </Layout>
  );
};

export default Home;
